import React, { useEffect, useState } from 'react';

const bannerStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 9999,
  background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)',
  color: '#fff',
  padding: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
  borderBottom: '3px solid #10b981',
  fontSize: '16px',
  fontWeight: '500',
  flexWrap: 'wrap'
};

const textStyle = {
  fontSize: '14px',
  lineHeight: 1.4,
  maxWidth: '600px',
  fontWeight: '500',
  flex: '1',
  minWidth: '250px'
};

const actionsStyle = {
  display: 'flex',
  gap: '8px',
  flexShrink: 0,
  alignItems: 'center'
};

const btnBase = {
  border: 'none',
  borderRadius: '6px',
  padding: '10px 16px',
  fontSize: '14px',
  cursor: 'pointer',
  fontWeight: '600',
  transition: 'all 0.2s ease',
  minWidth: '100px',
  whiteSpace: 'nowrap'
};

const primaryBtn = {
  ...btnBase,
  background: '#10b981',
  color: '#0b1f17',
  boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)'
};

const secondaryBtn = {
  ...btnBase,
  background: 'transparent',
  color: '#d1d5db',
  border: '2px solid #4b5563',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
};

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem('marketing_consent');
      if (consent !== 'true' && consent !== 'false') {
        setVisible(true);
      }
    } catch (_) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const onAccept = () => {
    try { localStorage.setItem('marketing_consent', 'true'); } catch (_) {}
    setVisible(false);
    // Reload so analytics gated by consent can initialize
    window.location.reload();
  };

  const onReject = () => {
    try { localStorage.setItem('marketing_consent', 'false'); } catch (_) {}
    setVisible(false);
  };

  return (
    <div style={bannerStyle} role="dialog" aria-live="polite" aria-label="Cookie consent banner">
      <div style={textStyle}>
        We use cookies to run the site and for analytics so we can improve Pulc. You can change your choice anytime in settings.
      </div>
      <div style={actionsStyle}>
        <button style={secondaryBtn} onClick={onReject}>Reject</button>
        <button style={primaryBtn} onClick={onAccept}>Accept</button>
      </div>
    </div>
  );
}


